<template>
  <div>
    <tenant-base-layout
      :can-user-edit="canUserEdit"
      :error-object="errorObject"
      :is-delete-visible="false"
      :is-loading="isLoading"
      :is-save-disabled="!content_de && !content_fr && !content_it"
      @save="saveContent"
      @cancel-edit="resetForm"
    >
      <div>
        <div v-if="langFilter.some((lang) => lang.ref === 'de-CH')">
          <label class="font-weight-bold"> Deutsch</label>
          <tiny-mce-editor
            v-if="canUserEdit"
            v-model="content_de"
            :tag-cite="false"
            :tag-smartcom="false"
            toolbar="| searchreplace | removeformat | copy pasteastext  cut  | undo redo"
          />
          <div
            v-else-if="content_de"
            v-safe-html="content_de"
          />
          <p v-else>
            -
          </p>
          <hr>
        </div>

        <div v-if="langFilter.some((lang) => lang.ref === 'fr-CH')">
          <label class="font-weight-bold"> Französisch</label>
          <tiny-mce-editor
            v-if="canUserEdit"
            v-model="content_fr"
            :tag-cite="false"
            :tag-smartcom="false"
            toolbar="| searchreplace | removeformat | copy pasteastext  cut  | undo redo"
          />
          <div
            v-else-if="content_fr"
            v-safe-html="content_fr"
          />
          <p v-else>
            -
          </p>
          <hr>
        </div>

        <div v-if="langFilter.some((lang) => lang.ref === 'it-CH')">
          <label class="font-weight-bold">Italienisch</label>
          <tiny-mce-editor
            v-if="canUserEdit"
            v-model="content_it"
            :tag-cite="false"
            :tag-smartcom="false"
            toolbar="| searchreplace | removeformat | copy pasteastext  cut  | undo redo"
          />
          <div
            v-else-if="content_it"
            v-safe-html="content_it"
          />
          <p v-else>
            -
          </p>
          <hr>
        </div>

        <div>
          <label
            class="font-weight-bold"
          >Was ist neu in Tenants übernehmen:</label>
          <div
            v-for="tenant in availableTenants"
            :key="tenant.id"
          >
            <v-checkbox
              v-model="selectedTenants"
              :disabled="!(canUserEdit && ($IsUserInRole('VertragsmanagementVerwaltung') || ($IsUserInRole('VertragsmanagementUniaVertragsverantworlich') && (tenant.tenantId === 4 ))))"
              :label="getTenantTitle(tenant.tenantId)"
              :value="tenant.tenantId"
              class="mt-0 mb-0"
              color="primary"
            />
          </div>
        </div>
      </div>
    </tenant-base-layout>
  </div>
</template>

<script>
import {
  GetPublicationFillCnt,
  GetPublicationSrc,
} from "@/services/contract.tenants.service";
import TinyMceEditor from "@/components/common/tinyMceEditor.vue";
import TenantBaseLayout from "@/components/contract/version/tenant/BaseLayout.vue";

export default {
  name: "TenantWhatsNewSection",
  components: { TenantBaseLayout, TinyMceEditor },

  props: {
    contractId: { type: String, default: "" },
    versionId: { type: Number, default: 0 },
    availableTenants: {
      type: Array,
      default: () => [],
    },
    allTenants: {
      type: Array,
      default: () => [],
    },
    langFilter: {
      type: Array,
      default: () => [
        { ref: "de-CH", name: "Deutsch" },
        { ref: "fr-CH", name: "Französisch" },
        { ref: "it-CH", name: "Italienisch" },
      ],
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      publication: {
        id: 0,
        tenantIds: [],
        versionId: this.versionId,
        publicationSourceContent: [
          {
            id: 0,
            publicationSourceId: 0,
            language: "de-CH",
            value: "",
          },
          {
            id: 0,
            publicationSourceId: 0,
            language: "fr-CH",
            value: "",
          },
          {
            id: 0,
            publicationSourceId: 0,
            language: "it-CH",
            value: "",
          },
        ],
      },
      isLoading: false,
      errorObject: null,
      content_de: "",
      content_fr: "",
      content_it: "",
      selectedTenants: [],
    };
  },
  created() {
    this.getPublicationsSrc();
  },
  methods: {
    getTenantTitle(tenantId) {
      const tenant = this.allTenants.find((t) => t.id === tenantId);
      return tenant ? tenant.bezeichnung : "";
    },
    getPublicationsSrc() {
      this.isLoading = true;
      GetPublicationSrc(
        this.versionId,
        (response) => {
          const publication = response.data;

          if (
            publication &&
            publication.id &&
            publication.publicationSourceContent &&
            publication.publicationSourceContent.length
          ) {
            publication.publicationSourceContent.forEach((content) => {
              switch (content.language) {
                case "de-CH":
                  this.content_de = content.value ? content.value : "";
                  break;
                case "fr-CH":
                  this.content_fr = content.value ? content.value : "";
                  break;
                case "it-CH":
                  this.content_it = content.value ? content.value : "";
                  break;
              }
            });
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    saveContent() {
      this.isLoading = true;
      //set content of sourceDto
      this.publication.publicationSourceContent.forEach((content) => {
        switch (content.language) {
          case "de-CH":
            content.value = this.content_de;
            break;
          case "fr-CH":
            content.value = this.content_fr;
            break;
          case "it-CH":
            content.value = this.content_it;
            break;
        }
      });
      this.publication.tenantIds = this.selectedTenants;
      GetPublicationFillCnt(
        this.publication,
        () => {
          this.isLoading = false;
          this.$emit("save");
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    resetForm() {
      this.getPublicationsSrc();
      this.selectedTenants = [];
    },
  },
};
</script>

<style scoped></style>
